<template>
    <span>{{ organizationTypeString(params.value) }}</span>
</template>

<script>
export default {
    name: 'CellRendererType',
    computed: {
        organizationTypeString() {
            return (value) => {
                switch (value) {
                    case 'education':
                        return 'Giáo dục';
                    case 'company':
                        return 'Công ty';
                    case 'shop':
                        return 'Cửa hàng';
                    default:
                        return '';
                }
            }
        }
    }
}
</script>
